// 旧的组织(即将废弃)
export default [
  // 企业
  {
    path: '/organization/enterprise',
    name: 'org-enterprise',
    component: () => import(/* webpackChunkName: "org-old" */ '@/views/organization/enterprise/Index.vue'),
    meta: { title: '组织管理' },
  },
  {
    path: '/organization/enterprise/add',
    name: 'org-enterprise-add',
    component: () => import(/* webpackChunkName: "org-old" */ '@/views/organization/enterprise/add/Add.vue'),
    meta: { title: '组织管理' },
  },
  {
    path: '/organization/enterprise/sub/:orgId',
    name: 'org-enterprise-sub',
    component: () => import(/* webpackChunkName: "org-old" */ '@/views/organization/enterprise/sub/Index.vue'),
    meta: { title: '组织管理' },
  },
  {
    path: '/organization/enterprise/auth/:orgId',
    name: 'org-enterprise-auth',
    component: () => import(/* webpackChunkName: "org-old" */ '@/views/organization/enterprise/auth/Index.vue'),
    meta: { title: '组织授权' },
  },
  {
    path: '/organization/enterprise/competitor/:orgId',
    name: 'org-enterprise-competitor',
    component: () => import(/* webpackChunkName: "org-old" */ '@/views/organization/enterprise/competitor/Index.vue'),
    meta: { title: '组织竞品' },
  },
  {
    path: '/organization/enterprise/service/:orgId',
    name: 'org-enterprise-service',
    component: () => import(/* webpackChunkName: "org-old" */ '@/views/organization/enterprise/service/Index.vue'),
    meta: { title: '组织增值服务' },
  },

  // 会员
  {
    path: '/organization/member',
    name: 'org-member',
    component: () => import(/* webpackChunkName: "org-old" */ '@/views/organization/member/Index.vue'),
    meta: { title: '会员管理' },
  },
  {
    path: '/organization/member/add',
    name: 'org-member-add',
    component: () => import(/* webpackChunkName: "org-old" */ '@/views/organization/member/Add.vue'),
    meta: { title: '会员管理' },
  },
  {
    path: '/organization/member/adjust/:orgId',
    name: 'org-member-adjust',
    component: () => import(/* webpackChunkName: "org-old" */ '@/views/organization/member/Adjust.vue'),
    meta: { title: '会员管理' },
  },
  {
    path: '/organization/member/auth/:orgId',
    name: 'org-member-auth',
    component: () => import(/* webpackChunkName: "org-old" */ '@/views/organization/enterprise/auth/Index.vue'),
    meta: { title: '会员授权' },
  },
  {
    path: '/organization/member/service/:orgId',
    name: 'org-member-service',
    component: () => import(/* webpackChunkName: "org-old" */ '@/views/organization/enterprise/service/Index.vue'),
    meta: { title: '增值服务' },
  },
];
